import React from "react";
import moment from "moment";

import { fetchApi } from "../../Network/NetworkService";
import { notif } from "../Ui/Notification";

import "../../Assets/Pages/dermatoSdr.css";
import IconTooltip from "../Ui/IconTooltip";

// « Abonnements & reconsultations — tracking », deux onglets :
//  - Abonnements : une ligne par activation réelle (webhook Stripe), avec la
//    source qui y a mené, le médecin de la consultation d'origine et le nombre
//    de consultations créées ensuite (hors incomplètes).
//  - Nouvelles consultations : une ligne par demande dont les utm (stockés à
//    la création) viennent de la famille « suivi », avec le médecin de la
//    consultation PRÉCÉDENTE du patient.
// Données écrites par feeli-server ; attribution = dernier contact capturé.
const SOURCE_LABELS = {
  naturel: { label: "Naturel", color: "#888" },
  anterieur: { label: "Antérieur (reconstitué)", color: "#9e9e9e" },
  whatsapp: { label: "Suivi (WhatsApp)", color: "#1da851" },
  "mail-reco": { label: "Mail reco médecin (+1 h)", color: "#2b7cd1" },
  "mail-1er-suivi": { label: "1er suivi (mail J+3)", color: "#02ce26" },
  "mail-nouveau-suivi": { label: "Nouveau suivi (mail J+7/J+30)", color: "#f59e0b" },
  "ecran-suivi": { label: "Écran fin de suivi", color: "#54b6d6" },
  "ecran-suivi-dermato": { label: "Écran fin suivi dermato", color: "#54b6d6" },
  "ecran-suivi-pathologie": { label: "Écran fin suivi pathologie", color: "#54b6d6" },
  autre: { label: "Autre (utm)", color: "#8e44ad" },
};

const RECONSULT_SOURCE_LABELS = {
  "suivi-dermato": { label: "Suivi dermato (reconsulter)", color: "#2b7cd1" },
  "suivi-pathologie": { label: "Suivi pathologie (nouvelle question)", color: "#2b7cd1" },
  "suivi-posttlc": { label: "Suivi post-TLC (recontacter)", color: "#54b6d6" },
  whatsapp: { label: "Relance WhatsApp", color: "#1da851" },
  "mail-1er-suivi": { label: "1er suivi (mail J+3)", color: "#02ce26" },
  "mail-nouveau-suivi": { label: "Nouveau suivi (mail J+7/J+30)", color: "#f59e0b" },
  "mail-reco": { label: "Mail reco médecin (+1 h)", color: "#2b7cd1" },
  "ecran-suivi": { label: "Écran fin de suivi", color: "#54b6d6" },
  "autre-suivi": { label: "Autre lien de suivi", color: "#8e44ad" },
};

const SUIVI_TYPE_LABELS = {
  posttlc: "Post-TLC",
  dermato: "Dermato",
  pathologie: "Pathologie",
};

const STATUS_LABELS = {
  active: "Actif",
  trialing: "Essai",
  past_due: "En retard",
  unpaid: "Impayé",
  incomplete: "Incomplet",
  incomplete_expired: "Expiré",
  canceled: "Annulé",
};

const REQUEST_STATE_LABELS = {
  waiting: "En attente",
  approved: "Acceptée",
  reviewed: "Examinée",
  terminated: "Terminée",
  canceled: "Annulée",
  refunded: "Remboursée",
  toCall: "À appeler",
};

const sourceBadge = (meta, title) => (
  <span
    title={title || ""}
    style={{
      display: "inline-block",
      background: meta.color,
      color: "#fff",
      borderRadius: 12,
      padding: "2px 10px",
      fontSize: 12,
      whiteSpace: "nowrap",
    }}
  >
    {meta.label}
  </span>
);

class SubscriptionsAttribution extends React.Component {
  constructor() {
    super();
    this.state = {
      view: "abonnements",
      items: [],
      bySource: [],
      // Taux de consultation après abonnement (vue abonnements) : part des
      // abonnements activés de la sélection suivis d'au moins une consultation.
      consultAfter: { activated: 0, withConsult: 0 },
      missing: 0,
      periodTotal: 0,
      countItems: 0,
      totalPage: 0,
      page: 1,
      source: "all",
      startDate: "",
      endDate: "",
      loading: false,
      loaded: false,
      backfilling: false,
    };
  }

  componentDidMount() {
    this.fetchList();
  }

  fetchList = () => {
    const { view, page, source, startDate, endDate } = this.state;
    const base =
      view === "abonnements"
        ? "/subscriptions/attribution/list"
        : "/subscriptions/attribution/reconsult/list";
    this.setState({ loading: true });
    fetchApi(
      base +
        "?page=" +
        page +
        "&source=" +
        source +
        (startDate ? "&start=" + startDate : "") +
        (endDate ? "&end=" + endDate + "T23:59:59" : ""),
    )
      .then((res) => {
        this.setState({
          items: res.items || [],
          bySource: res.bySource || [],
          consultAfter: res.consultAfter || { activated: 0, withConsult: 0 },
          missing: res.missing || 0,
          periodTotal: res.periodTotal || 0,
          countItems: res.countItems || 0,
          totalPage: res.countPages || 0,
          loaded: true,
          loading: false,
        });
      })
      .catch(() => {
        notif.addNotification(
          "Erreur",
          "Erreur de récupération de l'attribution",
          "warning",
        );
        this.setState({ loading: false });
      });
  };

  setView = (view) => {
    if (view === this.state.view) return;
    this.setState(
      { view, items: [], bySource: [], page: 1, source: "all", loading: true },
      this.fetchList,
    );
  };

  updateFilters = (patch) => {
    this.setState({ ...patch, page: 1, items: [], loading: true }, this.fetchList);
  };

  updatePage(page) {
    this.setState({ items: [], page, loading: true }, this.fetchList);
  }

  // Reconstitution des abonnés antérieurs : feeli-server relit Stripe par
  // lots de 100 — on relance tant que `remaining` > 0.
  backfill = () => {
    if (this.state.backfilling) return;
    this.setState({ backfilling: true });
    fetchApi("/subscriptions/attribution/backfill", { method: "POST" })
      .then((res) => {
        const remaining = res.remaining || 0;
        notif.addNotification(
          "Reconstitution",
          (res.created || 0) +
            " abonnement(s) daté(s)" +
            (res.neverActivated ? ", " + res.neverActivated + " jamais aboutis" : "") +
            (remaining > 0
              ? " — " + remaining + " restants, cliquez à nouveau."
              : " — terminé."),
          "success",
        );
        this.setState({ backfilling: false }, this.fetchList);
      })
      .catch((err) => {
        notif.addNotification(
          "Erreur",
          typeof err === "string" ? err : "Échec de la reconstitution",
          "warning",
        );
        this.setState({ backfilling: false });
      });
  };

  // Cartes de répartition par source : compte, libellé, part du total en
  // mini-barre. Cliquer une carte filtre la liste (Total = tout) ; la carte
  // active porte son accent. bySource reste la répartition COMPLÈTE côté
  // serveur, même quand un filtre est actif.
  renderStatsCards(labels) {
    const { bySource, source } = this.state;
    const totalShown = bySource.reduce((sum, s) => sum + s.count, 0);
    const pct = (count) =>
      totalShown ? Math.round((count / totalShown) * 100) : 0;
    const card = (key, label, color, count) => (
      <button
        key={key}
        type="button"
        className={"attrib-stat-card" + (source === key ? " active" : "")}
        style={{ "--accent": color }}
        title={pct(count) + " % du total"}
        onClick={() => this.updateFilters({ source: key })}
      >
        <p className="attrib-stat-value">{count}</p>
        <p className="attrib-stat-label">{label}</p>
        <div className="attrib-stat-bar">
          <span style={{ width: (count ? Math.max(3, pct(count)) : 0) + "%" }} />
        </div>
      </button>
    );

    return (
      <div className="attrib-stats">
        {card("all", "Total", "#14375F", totalShown)}
        {bySource.map((s) => {
          const meta = labels[s._id] || { label: s._id, color: "#888" };
          return card(s._id, meta.label, meta.color, s.count);
        })}
      </div>
    );
  }

  // Bandeau « taux de consultation après abonnement » : withConsult/activated
  // sur la sélection courante (le serveur applique les mêmes filtres
  // source/dates que la liste) — cliquer une carte source recalcule le taux
  // pour cette source.
  renderConsultRate() {
    const { consultAfter, source } = this.state;
    const { activated, withConsult } = consultAfter;
    if (!activated) return null;
    const rate = Math.round((withConsult / activated) * 100);
    return (
      <div className="attrib-rate" style={{ "--accent": "#0f9d58" }}>
        <p className="attrib-rate-value">{rate + " %"}</p>
        <div className="attrib-rate-body">
          <p className="attrib-rate-label">
            {"Taux de consultation après abonnement"}
          </p>
          <p className="attrib-rate-detail">
            {withConsult +
              " abonnement(s) sur " +
              activated +
              " suivi(s) d'au moins une consultation après l'activation" +
              (source !== "all" ? " — source filtrée" : "") +
              " (hors incomplètes, filtres période appliqués)"}
          </p>
          <div className="attrib-rate-bar">
            <span style={{ width: Math.max(2, rate) + "%" }} />
          </div>
        </div>
      </div>
    );
  }

  renderFilters(labels) {
    const { source, startDate, endDate } = this.state;
    return (
      <div className="dermato-sdr-inline" style={{ marginTop: 10 }}>
        <div className="dermato-sdr-form-group">
          <label>Source</label>
          <select
            className="dermato-sdr-input"
            value={source}
            onChange={(e) => this.updateFilters({ source: e.target.value })}
          >
            <option value="all">Toutes</option>
            {Object.keys(labels).map((k) => (
              <option key={k} value={k}>
                {labels[k].label}
              </option>
            ))}
          </select>
        </div>
        <div className="dermato-sdr-form-group">
          <label>Du</label>
          <input
            type="date"
            className="dermato-sdr-input"
            value={startDate}
            onChange={(e) => this.updateFilters({ startDate: e.target.value })}
          />
        </div>
        <div className="dermato-sdr-form-group">
          <label>Au</label>
          <input
            type="date"
            className="dermato-sdr-input"
            value={endDate}
            onChange={(e) => this.updateFilters({ endDate: e.target.value })}
          />
        </div>
      </div>
    );
  }

  renderPagination() {
    const { page, totalPage } = this.state;
    return (
      <div className="dermatosdr-pagination">
        <p style={{ margin: 0, color: "#888", fontSize: 14 }}>
          Page <strong>{page}</strong> / {totalPage}
        </p>
        <div>
          {page > 1 && (
            <IconTooltip
              icon="fa fa-chevron-left"
              text="Page précédente"
              onClick={() => this.updatePage(page - 1)}
            />
          )}
          {page < totalPage && (
            <IconTooltip
              icon="fa fa-chevron-right"
              text="Page suivante"
              onClick={() => this.updatePage(page + 1)}
            />
          )}
        </div>
      </div>
    );
  }

  renderAbonnements() {
    const { items } = this.state;
    return (
      <table className="dermato-sdr-table">
        <thead>
          <tr>
            <th>{"Activé le"}</th>
            <th>Patient</th>
            <th>{"Médecin d'origine"}</th>
            <th>Source</th>
            <th>{"Suivi"}</th>
            <th>{"Consult. après"}</th>
            <th>Statut</th>
          </tr>
        </thead>
        <tbody>
          {items.map((it) => {
            const meta = SOURCE_LABELS[it.sourceLabel] || {
              label: it.sourceLabel || "—",
              color: "#888",
            };
            const o = it.origin || {};
            const detail = [o.utmSource, o.utmCampaign, o.utmContent]
              .filter(Boolean)
              .join(" · ");
            return (
              <tr key={it._id}>
                <td style={{ whiteSpace: "nowrap" }}>
                  {it.activatedAt
                    ? moment(it.activatedAt).format("DD/MM/YYYY HH:mm")
                    : "—"}
                </td>
                <td>
                  <div>{(it.FName || "") + " " + (it.LName || "")}</div>
                  <div style={{ color: "#888", fontSize: 12 }}>
                    {it.email || "—"}
                  </div>
                </td>
                <td>
                  {it.doctorFName || it.doctorLName ? (
                    "Dr " + (it.doctorFName || "") + " " + (it.doctorLName || "")
                  ) : (
                    <span style={{ color: "#888" }}>{"—"}</span>
                  )}
                </td>
                <td>{sourceBadge(meta, detail || "aucun utm")}</td>
                <td>
                  {SUIVI_TYPE_LABELS[it.originSuiviType] || (
                    <span style={{ color: "#888" }}>{"—"}</span>
                  )}
                </td>
                <td style={{ fontWeight: 600, color: "#2e7d32" }}>
                  {it.consultationsAfter}
                </td>
                <td>
                  {STATUS_LABELS[it.subscriptionStatus] ||
                    it.subscriptionStatus ||
                    "—"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  renderReconsultations() {
    const { items } = this.state;
    return (
      <table className="dermato-sdr-table">
        <thead>
          <tr>
            <th>{"Créée le"}</th>
            <th>Patient</th>
            <th>{"Médecin précédent"}</th>
            <th>Source</th>
            <th>Type</th>
            <th>{"État"}</th>
          </tr>
        </thead>
        <tbody>
          {items.map((it) => {
            const meta = RECONSULT_SOURCE_LABELS[it.sourceLabel] || {
              label: it.sourceLabel || "—",
              color: "#888",
            };
            const detail = [it.utm_source, it.utm_campaign, it.utm_content]
              .filter(Boolean)
              .join(" · ");
            return (
              <tr key={it._id}>
                <td style={{ whiteSpace: "nowrap" }}>
                  {moment(it.createdAt).format("DD/MM/YYYY HH:mm")}
                </td>
                <td>
                  <div>{(it.FName || "") + " " + (it.LName || "")}</div>
                  <div style={{ color: "#888", fontSize: 12 }}>
                    {it.email || "—"}
                  </div>
                </td>
                <td>
                  {it.prevDoctorFName || it.prevDoctorLName ? (
                    <div>
                      {"Dr " +
                        (it.prevDoctorFName || "") +
                        " " +
                        (it.prevDoctorLName || "")}
                      {it.prevCreatedAt && (
                        <div style={{ color: "#888", fontSize: 12 }}>
                          {"consult. du " +
                            moment(it.prevCreatedAt).format("DD/MM/YYYY")}
                        </div>
                      )}
                    </div>
                  ) : (
                    <span style={{ color: "#888" }}>{"1re consultation"}</span>
                  )}
                </td>
                <td>{sourceBadge(meta, detail)}</td>
                <td>{it.type || "—"}</td>
                <td>{REQUEST_STATE_LABELS[it.state] || it.state}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  render() {
    const {
      view,
      items,
      missing,
      periodTotal,
      countItems,
      loading,
      loaded,
      backfilling,
    } = this.state;
    const labels = view === "abonnements" ? SOURCE_LABELS : RECONSULT_SOURCE_LABELS;

    return (
      <div className="dermato-sdr-container">
        <div className="dermato-sdr-header">
          <h2 className="dermato-sdr-title">
            {"Abonnements & reconsultations — tracking"}
          </h2>
          <button
            className="dermato-sdr-btn dermatosdr-btn-link"
            onClick={() => this.props.history.push("/subscriptions")}
          >
            {"← Abonnements (facturation)"}
          </button>
        </div>

        <div className="dermato-sdr-card">
          <div className="dermato-sdr-inline" style={{ marginBottom: 8 }}>
            <button
              className={
                "dermato-sdr-btn " +
                (view === "abonnements"
                  ? "dermatosdr-btn-primary"
                  : "dermatosdr-btn-link")
              }
              onClick={() => this.setView("abonnements")}
            >
              {"Abonnements"}
            </button>
            <button
              className={
                "dermato-sdr-btn " +
                (view === "reconsultations"
                  ? "dermatosdr-btn-primary"
                  : "dermatosdr-btn-link")
              }
              onClick={() => this.setView("reconsultations")}
            >
              {"Nouvelles consultations"}
            </button>
          </div>

          <h3 className="dermato-sdr-card-title">
            {view === "abonnements"
              ? "Activations d'abonnement"
              : "Consultations issues des suivis"}{" "}
            ({countItems})
          </h3>
          <p style={{ color: "#888", fontSize: 14, marginTop: -8 }}>
            {view === "abonnements"
              ? "Chaque ligne = une activation réelle (webhook Stripe), avec la source qui y a mené, le médecin de la consultation d'origine et le nombre de consultations créées ensuite (hors incomplètes). « Antérieur » = abonné d'avant le tracking, reconstitué via Stripe."
              : "Chaque ligne = une demande (hors incomplètes) dont les utm stockés à la création viennent d'un suivi : liens « reconsulter », mails du questionnaire (J+3 / renvois), relances WhatsApp. « Médecin précédent » = celui de la dernière consultation du patient avant celle-ci. Attribution au dernier contact — " +
                periodTotal +
                " demandes au total sur la période."}
          </p>

          {this.renderStatsCards(labels)}
          {view === "abonnements" && this.renderConsultRate()}
          {view === "abonnements" && missing > 0 && (
            <div style={{ marginTop: 8 }}>
              <button
                className="dermato-sdr-btn dermatosdr-btn-primary"
                disabled={backfilling}
                onClick={this.backfill}
              >
                {backfilling
                  ? "Reconstitution..."
                  : "Reconstituer " + missing + " abonné(s) antérieur(s)"}
              </button>
            </div>
          )}

          {this.renderFilters(labels)}

          {loading ? (
            <div className="dermato-sdr-empty">
              <span className="loader" />
            </div>
          ) : loaded && items.length === 0 ? (
            <div className="dermato-sdr-empty">
              {view === "abonnements"
                ? "Aucune activation sur ces critères."
                : "Aucune consultation issue d'un suivi sur ces critères."}
            </div>
          ) : items.length > 0 ? (
            <div>
              {view === "abonnements"
                ? this.renderAbonnements()
                : this.renderReconsultations()}
              {this.renderPagination()}
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default SubscriptionsAttribution;
